import { useEffect, useRef, useState } from 'react';
import logo from '../assets/logo.png';
import doener from '../assets/food/doenerteller.jpg';
import rollo from '../assets/food/rollo-classic-80.jpg';
import bowl from '../assets/food/falafel-bowl-04.jpg';
import pideClassic from '../assets/food/pide-classic.png';
import pideMixed from '../assets/food/pide-mixed.png';
import pideSucuk from '../assets/food/pide-sucuk.png';
import pideTonno from '../assets/food/pide-tonno.png';
import pizzaMozzarellaRucola from '../assets/food/pizza-mozzarella-rucola.png';
import pizzaMargherita from '../assets/food/pizza-margherita.png';
import pizzaSalami from '../assets/food/pizza-salami.png';
import koefteTeller from '../assets/food/koefte-teller.jpg';
import cigkoefteSushi from '../assets/food/cigkoefte-sushi.png';
import lahmacunStaged from '../assets/food/lahmacun-staged.png';
import burgerWithFries from '../assets/food/burger-with-fries.png';
import chickenBowlStaged from '../assets/food/chicken-bowl-staged.png';
import locationHero from '../assets/layla-location-hero.png';
import cafeSpotLogo from '../assets/cafe-spot-logo.png';
import burgerSpotLogo from '../assets/burger-spot-logo.png';
import familyPortrait from '../assets/layla-family-portrait.jpg';

const menus = [
  ['Hauptkarte', 'Montag–Freitag & Sonntag', 'https://layla-food.s3.us-east-2.amazonaws.com/layla-food-menu.pdf', logo],
  ['Samstagsmenü', 'Burger-Vibes, Pizza-Liebe, Köfte & Çiğköfte', 'https://layla-food.s3.us-east-2.amazonaws.com/layla-food-burger-special.pdf', burgerSpotLogo],
  ['Café Spot', 'Kaffee-Kicks, Matcha-Momente, Iced Latte & Cupcake-Liebe', 'https://layla-food.s3.us-east-2.amazonaws.com/layla-food-cafe-spot.pdf', cafeSpotLogo],
];

const categories = [
  'Döner & More',
  'Pizza',
  'Burger',
  'Rollo',
  'Dürüm',
  'Pide',
  'Türkische Pizza',
  'Köfte',
  'Çiğköfte',
  'Salate & Bowls',
  'Cupcakes',
  'Matcha',
  'Café',
];

const CategoryLoop = ({ hidden = false }: { hidden?: boolean }) => (
  <div className="ticker-group" aria-hidden={hidden || undefined}>
    {categories.map((category) => (
      <span className="ticker-item" key={category}>
        <span>{category}</span><i />
      </span>
    ))}
  </div>
);

type DishSlide = { src: string; alt: string };

const bowlSlides: DishSlide[] = [
  { src: bowl, alt: 'Bunte Falafel Bowl' },
  { src: chickenBowlStaged, alt: 'Frische Chicken Bowl mit Salat und Sauce' },
];

const pizzaSlides: DishSlide[] = [
  { src: pizzaMozzarellaRucola, alt: 'Pizza mit Mozzarella, Tomaten und Rucola' },
  { src: pizzaMargherita, alt: 'Pizza Margherita mit Mozzarella und Basilikum' },
  { src: pizzaSalami, alt: 'Pizza Salami mit Käse' },
];

const pideSlides: DishSlide[] = [
  { src: pideClassic, alt: 'Pide Classic mit frischem Salat und Sauce' },
  { src: pideMixed, alt: 'Gemischte Pide mit frischem Salat und Sauce' },
  { src: pideSucuk, alt: 'Pide mit Sucuk, frischem Salat und Sauce' },
  { src: pideTonno, alt: 'Pide Tonno mit frischem Salat und Sauce' },
];

const koefteSlides: DishSlide[] = [
  { src: koefteTeller, alt: 'Köfte-Teller mit Reis, Salat und Saucen' },
  { src: cigkoefteSushi, alt: 'Crunchy Çiğköfte-Sushi mit frischem Gemüse' },
];

const DishCarousel = ({ slides }: { slides: DishSlide[] }) => {
  const [active, setActive] = useState(0);
  const touchStart = useRef<number | null>(null);

  const finishSwipe = (x: number) => {
    if (touchStart.current === null) return;
    const distance = x - touchStart.current;
    if (Math.abs(distance) > 45) {
      setActive((current) => distance < 0
        ? (current + 1) % slides.length
        : (current - 1 + slides.length) % slides.length);
    }
    touchStart.current = null;
  };

  return (
    <div
      className="dish-image dish-carousel"
      onTouchStart={(event) => { touchStart.current = event.touches[0].clientX; }}
      onTouchEnd={(event) => finishSwipe(event.changedTouches[0].clientX)}
    >
      <div className="carousel-track" style={{ transform: `translateX(-${active * 100}%)` }}>
        {slides.map((slide) => <img src={slide.src} alt={slide.alt} key={slide.src} />)}
      </div>
      <div className="carousel-arrows">
        <button type="button" className="previous" onClick={() => setActive((active - 1 + slides.length) % slides.length)} aria-label="Vorheriges Bild"><Arrow /></button>
        <button type="button" onClick={() => setActive((active + 1) % slides.length)} aria-label="Nächstes Bild"><Arrow /></button>
      </div>
    </div>
  );
};

const Arrow = () => <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>;
const Phone = () => <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" /></svg>;

const RootPage = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const closeMobileMenu = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.currentTarget.closest('details')?.removeAttribute('open');
  };

  useEffect(() => {
    const updateBackToTop = () => setShowBackToTop(window.scrollY > 500);
    updateBackToTop();
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    return () => window.removeEventListener('scroll', updateBackToTop);
  }, []);

  return (
  <div className="site">
    <header>
      <a className="brand" href="#start" aria-label="Layla Food Startseite"><img src={logo} alt="Layla Food" /></a>
      <nav aria-label="Hauptnavigation"><a href="#gerichte">Gerichte</a><a href="#ueber-uns">Über uns</a><a href="#speisekarten">Speisekarten</a><a href="#besuch">Besuch uns</a></nav>
      <details className="mobile-menu">
        <summary aria-label="Navigation öffnen"><span /><span /><span /></summary>
        <div><a href="#gerichte" onClick={closeMobileMenu}>Gerichte</a><a href="#ueber-uns" onClick={closeMobileMenu}>Über uns</a><a href="#speisekarten" onClick={closeMobileMenu}>Speisekarten</a><a href="#besuch" onClick={closeMobileMenu}>Besuch uns</a></div>
      </details>
      <a className="head-cta" href="tel:+494271955255">Vorbestellen</a>
    </header>

    <main>
      <section className="hero" id="start">
        <div className="hero-copy">
          <p className="eyebrow">Layla Food · More than you think</p>
          <h1>Schnell gemacht.<span>Mit Liebe serviert.</span></h1>
          <p className="lead">Döner, Pizza, Burger und mehr – frisch zubereitet für deinen großen und kleinen Hunger.</p>
          <div className="actions"><a className="button primary" href="#speisekarten">Speisekarte ansehen <Arrow /></a><a className="button ghost" href="tel:+494271955255"><Phone /> 0 42 71 / 955 255</a></div>
        </div>
        <div className="hero-art" aria-hidden="true">
          <div className="hero-photo"><img src={locationHero} alt="Layla Food Restaurant in Sulingen" /></div>
        </div>
        <div className="ticker" aria-label="Unser Angebot">
          <div className="ticker-track">
            <CategoryLoop />
            <CategoryLoop hidden />
          </div>
        </div>
      </section>

      <section className="food" id="gerichte">
        <div className="section-title"><div><p className="eyebrow">Unsere Gerichte</p><h2>So schmeckt<br />Layla.</h2></div><p>Von knusprig bis knackig, von klassisch bis veggie: Entdecke, was hinter unseren beliebtesten Gerichten steckt.</p></div>
        <div className="dish-list">
          <article className="dish-row">
            <div className="dish-image"><img src={doener} alt="Mixed Dönerteller mit Pommes, Salat und Sauce" /></div>
            <div className="dish-copy"><p className="eyebrow">Der Klassiker</p><h3>Döner & More</h3><p>Saftiges Fleisch vom Drehspieß, knackiger Salat und deine Lieblingssauce – im Brot, als Dürüm oder großzügig auf dem Teller.</p></div>
          </article>
          <article className="dish-row">
            <div className="dish-image"><img src={rollo} alt="Frisch zubereiteter Rollo Classic" /></div>
            <div className="dish-copy"><p className="eyebrow">Frisch gerollt</p><h3>Rollo</h3><strong className="dish-highlight">Mit Käse überbacken</strong><p>Hausgemachter Teig, frisch belegt, fest eingerollt und goldbraun überbacken. Unser Rollo bleibt lange warm, lässt sich unkompliziert essen und ist damit der perfekte Begleiter zum Mitnehmen.</p></div>
          </article>
          <article className="dish-row">
            <DishCarousel slides={bowlSlides} />
            <div className="dish-copy"><p className="eyebrow">Frisch & bunt</p><h3>Salate & Bowls</h3><p>Knackiges Gemüse, frische Zutaten und cremige Saucen treffen aufeinander. Leicht, bunt und trotzdem richtig sättigend.</p></div>
          </article>
          <article className="dish-row">
            <DishCarousel slides={pizzaSlides} />
            <div className="dish-copy"><p className="eyebrow">Heiß aus dem Ofen</p><h3>Pizza</h3><p>Knuspriger Boden, würzige Tomatensauce und ordentlich Käse. Ob Margherita, Salami oder Mozzarella mit Rucola – jede Pizza kommt frisch und heiß aus dem Ofen.</p></div>
          </article>
          <article className="dish-row">
            <DishCarousel slides={pideSlides} />
            <div className="dish-copy"><p className="eyebrow">Türkisch aus dem Ofen</p><h3>Pide</h3><p>Schiffchenförmiger Teig, goldbraun gebacken und abwechslungsreich belegt – von Classic über Sucuk bis Tonno. Dazu gibt es frischen Salat und Sauce.</p></div>
          </article>
          <article className="dish-row">
            <div className="dish-image"><img src={lahmacunStaged} alt="Frisch gebackene türkische Pizza – Lahmacun" /></div>
            <div className="dish-copy"><p className="eyebrow">Original türkisch</p><h3>Türkische Pizza</h3><strong className="dish-highlight">Lahmacun</strong><p>Dünner, würziger Teig mit traditionellem Belag – pur, mit frischem Salat oder herzhaft gefüllt. Auf Wunsch servieren wir Lahmacun auch auf dem Teller mit Dönerfleisch und Salat als Beilage.</p></div>
          </article>
          <article className="dish-row">
            <div className="dish-image"><img src={burgerWithFries} alt="Layla Food Beef Burger mit Pommes" /></div>
            <div className="dish-copy"><p className="eyebrow">Immer da. Samstag noch mehr.</p><h3>Burger</h3><strong className="dish-highlight">Samstags ist Burger-Tag</strong><p>Unser Beef Classic und der Veggie Burger sind immer für dich da. Samstags legen wir noch eine Schippe drauf: Dann gibt es zusätzlich Chicken Burger und eine deutlich größere Auswahl an Beef Burgern.</p></div>
          </article>
          <article className="dish-row">
            <DishCarousel slides={koefteSlides} />
            <div className="dish-copy"><p className="eyebrow">Würzig & besonders</p><h3>Köfte & Çiğköfte</h3><strong className="dish-highlight">Unser Samstagsspecial</strong><p>Unsere Köfte bestehen aus 100 % Rindfleisch, werden nach traditioneller türkischer Art zubereitet und kommen wahlweise im Sandwich oder auf dem Teller mit Pommes und Salat. Çiğköfte servieren wir veggie oder – je nach Variante – sogar vegan: im Dürüm, als Teller mit Beilagen oder besonders crunchy als Çiğköfte-Sushi.</p></div>
          </article>
        </div>
      </section>

      <section className="about" id="ueber-uns">
        <div className="about-photo"><img src={familyPortrait} alt="Die Inhaber von Layla Food in ihrem Restaurant" /></div>
        <div className="about-copy">
          <p className="eyebrow">Seit 2010 in Sulingen</p>
          <h2>Klein geführt.<br />Groß im Herzen.</h2>
          <p className="about-lead">Layla Food ist ein kleines Familienunternehmen – persönlich geführt und seit 2010 fest in Sulingen zu Hause.</p>
          <p>Was bei uns auf den Tisch kommt, bereiten wir so zu, wie wir es auch unserer eigenen Familie servieren würden: frisch, ehrlich und mit viel Sorgfalt. Sauberkeit in der Küche, ein freundlicher Umgang und ein offenes Ohr für unsere Gäste gehören für uns genauso dazu wie gutes Essen.</p>
          <div className="about-values">
            <span><strong>Sauber</strong><small>Sorgfalt, die man sieht</small></span>
            <span><strong>Herzlich</strong><small>Gäste werden zu Stammgästen</small></span>
            <span><strong>Familiär</strong><small>Seit 2010 mit Leidenschaft</small></span>
          </div>
        </div>
      </section>

      <section className="menu" id="speisekarten">
        <div className="menu-copy"><p className="eyebrow">Was darf es sein?</p><h2>Unsere Speisekarten</h2><p>Entdecke unser gesamtes Angebot bequem als PDF.</p></div>
        <div className="menu-list">{menus.map(([title, sub, href, icon]) => <a href={href} target="_blank" rel="noopener noreferrer" key={title}><span className="menu-title">{icon && <img src={icon} alt={`${title} Logo`} />}<span><strong>{title}</strong><small>{sub}</small></span></span><i><Arrow /></i></a>)}</div>
      </section>

      <section className="visit" id="besuch">
        <div className="visit-copy"><p className="eyebrow">Komm vorbei</p><h2>Wir freuen uns<br />auf dich.</h2><p>Ob schnelles Mittagessen, Feierabend-Döner oder gemeinsames Essen mit der Familie – bei Layla Food bist du willkommen.</p><div className="contacts"><a href="https://maps.google.com/?q=Nienburger+Str.+1a,+27232+Sulingen" target="_blank" rel="noopener noreferrer"><small>Adresse</small>Nienburger Str. 1a<br />27232 Sulingen</a><a href="tel:+494271955255"><small>Telefon</small>0 42 71 / 955 255</a></div></div>
        <div className="hours"><h3>Öffnungszeiten</h3><dl><div><dt>Montag – Freitag</dt><dd>11:00 – 21:00 Uhr</dd></div><div><dt>Samstag</dt><dd>12:00 – 20:00 Uhr</dd></div><div><dt>Sonn- / Feiertage</dt><dd>12:00 – 21:00 Uhr</dd></div></dl><a className="button light" href="tel:+494271955255">Jetzt vorbestellen <Arrow /></a></div>
        <div className="google-review"><span aria-hidden="true">★</span><div><strong>Hat es dir geschmeckt?</strong><p>Mit deiner Google-Bewertung hilfst du uns und anderen Gästen.</p></div><a href="https://g.page/r/CQTx4u_lQ6MpEAE/review" target="_blank" rel="noopener noreferrer">Jetzt bewerten <Arrow /></a></div>
      </section>
    </main>

    <a className={`back-to-top${showBackToTop ? ' visible' : ''}`} href="#start" aria-label="Zurück nach oben"><Arrow /></a>
    <footer><img src={logo} alt="Layla Food" /><p>Fast Food. Family Food. Layla Food.</p><div><a href="/impressum">Impressum</a><a href="/datenschutz">Datenschutz</a><a href="mailto:info@layla-food.de">info@layla-food.de</a><a href="https://www.instagram.com/laylafoodsulingen" target="_blank" rel="noopener noreferrer">Instagram</a></div></footer>
  </div>
  );
};

export default RootPage;
